/*!

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { UserProvider } from "./providers/UserProvider";
import { AutomationProvider } from "./automation/AutomationProvider";
import InAppNotification from "./components/common/InAppNotification";
import { applyTheme, watchTheme } from "./preferences/theme";

// The saved theme goes on before the first paint, so a dark page doesn't flash light.
applyTheme();
watchTheme();

ReactDOM.render(
  <BrowserRouter>
    <UserProvider>
      <AutomationProvider>
        <InAppNotification>
          <App />
        </InAppNotification>
      </AutomationProvider>
    </UserProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
